<template>
  <div id="wrapper" class="row">
    <div id="leftPanel" class="col-md-2" v-if="hasFooterSlot">
      <slot name="leftPanel" />
    </div>

    <div id="centerPanel" class="col">
      <slot name="centerPanel" />
    </div>

    <div
      id="rightPanel"
      class="col"
      :class="{ withOutLeftPanel: !hasFooterSlot }"
    >
      <slot name="rightPanel" />
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

/**
 * Three Columns Layout Component by Sports `<ThreeCols />`
 *
 * @author Henry Gomez
 */
@Component()
export default class ThreeCols extends Vue {
  get hasFooterSlot() {
    return !!this.$slots.leftPanel
  }
}
</script>

<style lang="scss" scoped>
#wrapper {
  min-height: 100vh;
  margin: 0;

  #leftPanel {
    background-color: $gray-100;
    height: 100vh;
  }

  #centerPanel {
    background-color: #fff;
    min-height: 100vh;
    overflow: hidden;
    /* @include media-breakpoint-up(lg) {
      max-width: 463px;
    } */
  }

  @media (max-width: 1024px) {
    #centerPanel {
      max-width: 463px;
    }
  }

  #rightPanel {
    background-color: $gray-100;
    box-shadow: 0 -10px 20px #c9c9c9;

    height: 100vh;
    max-width: 390px;
    min-width: 390px;
    overflow-y: hidden;
    padding: 0;
    width: 390px;

    &.withOutLeftPanel {
      box-shadow: none;
      max-width: 45%;
    }
  }
}
</style>
